import React from "react";
import { connect } from "react-redux";

import HabitDetail from "./HabitDetail";
import getMyUserHabitProfile from "../../../../../_selectors/userSelectors/getMyUserHabitProfile";
const Habit = ({ userProfile, update, showToast }) => {
  return (
    <HabitDetail
      userProfile={userProfile}
      update={update}
      toast={showToast}
      showEdit={true}
    />
  );
};
const mapStateToProps = (state, ownProps) => ({
  userProfile: getMyUserHabitProfile(state)
});

export default connect(mapStateToProps)(Habit);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInformation/Habit/index.js